import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("APP_CRASH:", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <pre
          data-testid="app-crash"
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 999999,
            background: "#000",
            color: "#f66",
            padding: 24,
            fontSize: 16,
            whiteSpace: "pre-wrap",
            overflow: "auto",
          }}
        >
          {String(this.state.error && (this.state.error.stack || this.state.error.message || this.state.error))}
        </pre>
      );
    }
    return this.props.children;
  }
}
